module.exports = __webpack_public_path__ + "static/media/penetrating_blows.787f5b8c.png";